module.exports = __webpack_public_path__ + "static/media/caros-light-italic.a7e21556.woff";